// Mix topic images for default topics
import CivicsImage from "../../../../images/learner/mixTopics/civics.png";
import CodingImage from "../../../../images/learner/mixTopics/coding.png";
import CommunicationImage from "../../../../images/learner/mixTopics/communication.png";
import EconomicsImage from "../../../../images/learner/mixTopics/economics.png";
import EngineeringImage from "../../../../images/learner/mixTopics/engineering.png";
import FoodImage from "../../../../images/learner/mixTopics/food.png";
import ForeignLanguageImage from "../../../../images/learner/mixTopics/foreign-language.png";
import GamingImage from "../../../../images/learner/mixTopics/gaming.png";
import GeographyImage from "../../../../images/learner/mixTopics/geography.png";
import HealthImage from "../../../../images/learner/mixTopics/health.png";
import HistoryImage from "../../../../images/learner/mixTopics/history.png";
import LifeSkillsImage from "../../../../images/learner/mixTopics/life-skills.png";
import MathImage from "../../../../images/learner/mixTopics/math.png";
import MusicImage from "../../../../images/learner/mixTopics/music.png";
import NatureImage from "../../../../images/learner/mixTopics/nature.png";
import PerformingArtsImage from "../../../../images/learner/mixTopics/performing-arts.png";
import PhilosophyImage from "../../../../images/learner/mixTopics/philosophy.png";
import PsychologyImage from "../../../../images/learner/mixTopics/psychology.png";
import ReadingImage from "../../../../images/learner/mixTopics/reading.png";
import ScienceImage from "../../../../images/learner/mixTopics/science.png";
import SocialStudiesImage from "../../../../images/learner/mixTopics/social-studies.png";
import SportsImage from "../../../../images/learner/mixTopics/sports.png";
import TechnologyImage from "../../../../images/learner/mixTopics/technology.png";
import VisualArtImage from "../../../../images/learner/mixTopics/visual-art.png";
import WritingImage from "../../../../images/learner/mixTopics/writing.png";

export enum TopicFilter {
  All = "All",
  MyMixes = "My Mixes",
  DefaultTopics = "Default Topics",
}

export type DefaultTopic = {
  uid: string;
  title: string;
  description: string;
  attachmentUrl: string;
};

export type Topic = DefaultTopic & {
  isDefault: boolean;
};

export const DEFAULT_TOPICS: DefaultTopic[] = [
  {
    uid: "coding",
    title: "Coding",
    description:
      "In Coding, you'll become a digital wizard, creating your own video games, apps, and websites! Imagine being a game developer who designs thrilling adventures, a software engineer who builds cool programs for your favorite devices, or a web designer who makes the internet look awesome and fun!",
    attachmentUrl: CodingImage,
  },
  {
    uid: "music",
    title: "Music",
    description:
      "Dive into the magical world of music where you can become a melody maker, a rhythm explorer, or a sound storyteller! Imagine being a music producer, crafting catchy tunes like your favorite pop songs, or a concert promoter, bringing your favorite bands to life on stage for everyone to enjoy. Each note is an adventure waiting to unfold!",
    attachmentUrl: MusicImage,
  },
  {
    uid: "reading",
    title: "Reading",
    description:
      "Dive into the magical world of reading where stories come alive and adventures await on every page! You could become a book critic, sharing your thoughts about new stories, or a librarian, guiding friends through incredible worlds of imagination, or even a storyteller, weaving tales that captivate your audience like a wizard casting spells!",
    attachmentUrl: ReadingImage,
  },
  {
    uid: "visual-art",
    title: "Visual Art",
    description:
      "In Visual Art, you can unleash your creativity and become a painter, sculptor, or graphic designer, transforming your wildest ideas into amazing masterpieces! Imagine using colors like a wizard to create a magical landscape or crafting a sculpture that tells a story, inviting others to step into your imaginative world!",
    attachmentUrl: VisualArtImage,
  },
  {
    uid: "gaming",
    title: "Gaming",
    description:
      "Dive into the thrilling world of gaming, where you can become a game designer crafting epic adventures, a professional gamer battling for glory in tournaments, or a game journalist uncovering the latest secrets about your favorite titles! Imagine building entire universes or strategizing your way to victory like a hero on a quest—it's all possible in the amazing realm of gaming!",
    attachmentUrl: GamingImage,
  },
  {
    uid: "sports",
    title: "Sports",
    description:
      "In Sports, you'll dive into the thrilling world of games and competition, where you can become a sports commentator, making the action come alive for fans, or a coach, guiding players to victory like a master wizard crafting a winning spell! You could even be a sports photographer, capturing epic moments like a superhero freezing time with your camera. Get ready to kick, throw, and score your way into an exciting adventure!",
    attachmentUrl: SportsImage,
  },
  {
    uid: "nature",
    title: "Nature",
    description:
      "Dive into the amazing world of nature, where you can become a wildlife photographer capturing the secrets of the animal kingdom, an environmental scientist studying how plants grow, or even a park ranger protecting beautiful landscapes! Imagine exploring hidden forests like a treasure hunter or observing colorful birds as if you're a secret agent on a mission to discover their habits!",
    attachmentUrl: NatureImage,
  },
  {
    uid: "science",
    title: "Science",
    description:
      'Dive into the amazing world of science where you can become a "nature detective," exploring the secrets of plants and animals, or a "space explorer," investigating the mysteries of the universe! You could be a marine biologist studying colorful coral reefs, a chemist mixing potions to create cool reactions, or an environmental scientist helping to save our planet\'s precious resources!',
    attachmentUrl: ScienceImage,
  },
  {
    uid: "writing",
    title: "Writing",
    description:
      "Writing is like being a magician with words, where you can create entire worlds and characters that leap off the page! You could become a storyteller, crafting epic adventures like Harry Potter, a journalist uncovering the truth like a superhero for your town, or even a poet painting pictures with your phrases, just like Shel Silverstein did with his fun and silly verses!",
    attachmentUrl: WritingImage,
  },
  {
    uid: "social-studies",
    title: "Social Studies",
    description:
      "In Social Studies, you'll become a world explorer, diving into the stories of different cultures and histories! You could be a history detective, uncovering the mysteries of ancient civilizations, a community journalist, sharing stories about local heroes, or even a global citizen, learning how to make the world a better place by understanding different viewpoints.",
    attachmentUrl: SocialStudiesImage,
  },
  {
    uid: "math",
    title: "Math",
    description:
      "Math is like a superpower that helps you unlock the mysteries of the world around you! You can become a number-crunching engineer designing cool buildings, a tech-savvy game developer creating awesome video games, or even a clever data analyst solving puzzles that help businesses grow.",
    attachmentUrl: MathImage,
  },
  {
    uid: "history",
    title: "History",
    description:
      "Dive into the amazing world of History, where you'll become a time traveler exploring ancient civilizations, incredible battles, and famous leaders! Imagine being a museum curator who uncovers hidden treasures, a historian who tells thrilling stories of the past, or an archaeologist who digs up ancient artifacts to unlock the secrets of long-gone cultures!",
    attachmentUrl: HistoryImage,
  },
  {
    uid: "civics",
    title: "Civics",
    description:
      "Dive into Civics and become a superhero for your community! You can be a city council member, helping to make important decisions, or a community organizer, rallying your friends to stand up for what they believe in. Imagine being a journalist, uncovering the stories that shape our lives and making sure everyone's voice is heard!",
    attachmentUrl: CivicsImage,
  },
  {
    uid: "engineering",
    title: "Engineering",
    description:
      "In Engineering, you'll become a problem-solving superhero who designs everything from cool roller coasters to eco-friendly buildings! Imagine being a structural engineer who makes sure skyscrapers touch the clouds, or a mechanical engineer who creates robots that can help clean up our planet!",
    attachmentUrl: EngineeringImage,
  },
  {
    uid: "health",
    title: "Health",
    description:
      "In Health, you'll embark on an adventure to discover how to keep your body and mind strong and happy! You could become a nutritionist, helping people choose delicious foods that fuel their energy, or a personal trainer, guiding friends through fun exercises that make them feel like superheroes!",
    attachmentUrl: HealthImage,
  },
  {
    uid: "performing-arts",
    title: "Performing Arts",
    description:
      "In Performing Arts, you'll step into the spotlight and become a storyteller, using your body and voice to bring characters to life! You could be a dazzling actor on stage, a talented dancer who expresses emotions through movement, or a creative director who designs the entire show, bringing together all the magical elements like costumes and music!",
    attachmentUrl: PerformingArtsImage,
  },
  {
    uid: "psychology",
    title: "Psychology",
    description:
      "Dive into the amazing world of psychology, where you can become a mind detective! Discover how people think, feel, and behave by exploring careers like child psychologists who help kids understand their feelings, sports psychologists who help athletes conquer fear and stress, or even forensic psychologists who solve mysteries by studying criminal minds! Get ready to unlock the secrets of the human mind and help others along the way!",
    attachmentUrl: PsychologyImage,
  },
  {
    uid: "technology",
    title: "Technology",
    description:
      "Dive into the thrilling world of Technology, where you can become a master creator! Imagine being a game developer who designs epic adventures, a robotics engineer who builds cool robots to help people, or a software engineer who creates apps that make life easier—like a magic wand for your phone!",
    attachmentUrl: TechnologyImage,
  },
  {
    uid: "communication",
    title: "Communication",
    description:
      "In Communication, you'll unlock secret worlds of storytelling and connection! You could become a news anchor who shares exciting breaking news, a social media manager who crafts fun posts for your favorite brands, or a public speaker who inspires audiences with amazing stories. Get ready to express your ideas and connect with people all around the globe!",
    attachmentUrl: CommunicationImage,
  },
  {
    uid: "economics",
    title: "Economics",
    description:
      "Dive into the world of Economics and discover how money makes the world go round! You could become a financial analyst who helps people save for their dream vacations, a market researcher who uncovers what toys kids want most, or even an economist who advises governments on how to make their countries thrive!",
    attachmentUrl: EconomicsImage,
  },
  {
    uid: "food",
    title: "Food",
    description:
      "Get ready to embark on a delicious adventure in the world of food! You could become a chef, whipping up tasty dishes like pizza and cupcakes, or a food critic, tasting the yummiest treats and sharing your thoughts like a superhero of flavor! Imagine being a food photographer, capturing mouthwatering images that make everyone hungry just by looking at them!",
    attachmentUrl: FoodImage,
  },
  {
    uid: "geography",
    title: "Geography",
    description:
      "Get ready to explore the amazing world of Geography, where you can become a mapmaker, travel guide, or even a climate scientist! You'll uncover hidden treasures like mountain ranges, rivers, and cities, and discover how they connect to our everyday lives—it's like being an explorer on a grand adventure!",
    attachmentUrl: GeographyImage,
  },
  {
    uid: "foreign-languages",
    title: "Foreign Languages",
    description:
      "Dive into the amazing world of foreign languages, where you can unlock secret codes that allow you to chat with friends from all over the globe! Imagine being a translator, helping people understand each other, or a travel guide, leading adventurers through exciting new cultures, or even a language teacher, inspiring others to explore new tongues and stories!",
    attachmentUrl: ForeignLanguageImage,
  },
  {
    uid: "philosophy",
    title: "Philosophy",
    description:
      "Learn about philosophy, where you can become a thinker like a detective solving mysteries of existence! Imagine being a philosopher who asks big questions, a writer crafting stories about our beliefs, or a teacher inspiring others to explore what's right and wrong. You'll unlock secret worlds of ideas that help us understand ourselves and the universe!",
    attachmentUrl: PhilosophyImage,
  },
  {
    uid: "life-skills",
    title: "Life Skills",
    description:
      "With life skills, you'll become a superhero of everyday tasks, learning how to cook delicious meals, manage your money like a pro, and communicate clearly with others! Imagine being a chef whipping up your favorite dish, a financial wizard budgeting for that awesome video game, or a master negotiator resolving conflicts with friends.",
    attachmentUrl: LifeSkillsImage,
  },
];
